import { Box, Button, Menu, MenuItem } from "@showitinc/showit-wc";
import React from "react";
import styles from "./DesignSettingsCustomizeMenu.module.css";

/**
 * The Customize menu under a Design Settings state section: lists the props the state doesn't
 * customize yet, and adds one as a row when picked. Renders nothing when every prop is customized.
 * @param {Object} props
 * @param {{ value: string, label: string }[]} props.items - Props still available to customize.
 * @param {(value: string) => void} props.onSelect - Called with the picked item's value.
 * @param {boolean} [props.disabled] - Disables the trigger, e.g. for a locked element.
 * @param {string} [props.testId] - The trigger's `data-testid` and `data-e2e`.
 * @param {string} [props.itemTestIdPrefix] - Prefixes each item's value for its `data-testid`.
 * @returns {React.ReactElement | null}
 */
const DesignSettingsCustomizeMenu = ({
  items,
  onSelect,
  disabled = false,
  testId = "customize",
  itemTestIdPrefix = `${testId}-item-`,
}) =>
  items.length > 0 ? (
    <Box d="flex" justify="center" align="center" mb="1" mt="3" pr="1">
      <Menu shift="left" py="lg" className={styles.menu}>
        <Button
          iconPrefix="add"
          iconSize="20"
          variant="minimal"
          slot="trigger-element"
          popovertarget="menu"
          disabled={disabled}
          data-e2e={testId}
          data-testid={testId}
        >
          Customize
        </Button>
        {items.map(({ value, label }) => (
          <MenuItem
            key={value}
            onClick={() => onSelect(value)}
            data-testid={`${itemTestIdPrefix}${value}`}
          >
            {label}
          </MenuItem>
        ))}
      </Menu>
    </Box>
  ) : null;

export default DesignSettingsCustomizeMenu;
